import React from 'react';
import { TFunction } from 'i18next';
import { ViewAndActionButtons } from './ViewAndActionButtons';
import {
  BlockInteractionsState,
  ButtonsType,
  GetButtonModifier,
  GetHref,
  GetTitleText,
  ToggleActiveView,
  ViewsType,
} from '../BlockInteractionsTypes';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type BlockInteractionsButtons = {
  state: BlockInteractionsState;
  buttons?: ButtonsType;
  views: ViewsType;
  id: string;
  uuid: string;
  elementType: string;
  contentWrapperContext?: ContentWrapperContext | null;
  getTitleText: GetTitleText;
  getButtonModifier: GetButtonModifier;
  getHref: GetHref;
  isNestedInCollapsibleOrLayoutGroup?: boolean;
  toggleActiveView: ToggleActiveView;
  t: TFunction;
};

export function BlockInteractionsButtons({
  state,
  buttons,
  views,
  id,
  uuid,
  elementType,
  contentWrapperContext,
  getTitleText,
  getButtonModifier,
  getHref,
  isNestedInCollapsibleOrLayoutGroup,
  toggleActiveView,
  t,
}: BlockInteractionsButtons) {
  return (
    <div className="block-interactions__buttons">
      <ViewAndActionButtons
        state={state}
        buttons={buttons}
        views={views}
        id={id}
        uuid={uuid}
        elementType={elementType}
        contentWrapperContext={contentWrapperContext}
        getTitleText={getTitleText}
        getButtonModifier={getButtonModifier}
        getHref={getHref}
        isNestedInCollapsibleOrLayoutGroup={isNestedInCollapsibleOrLayoutGroup}
        toggleActiveView={toggleActiveView}
        t={t}
      />
    </div>
  );
}
